export default (function (_ua) {
	return {
		/** Set custom `userAgent` string */
		setUA: function (userAgent) {
			_ua = userAgent;
		},
		/** Detection by given function */
		detect: function (fn) {
			return fn(_ua);
		},
		/** Generate CSS class names string */
		classNames: function (classes) {
			return classes.map(function (item) {
				return item.fn(_ua) ? item.is : item.not;
			});
		}
	};
})(typeof navigator !== 'undefined' ? navigator.userAgent : '');
